import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {
  ContainerDivs,
  PlanScorecardCompanyVideo,
  PlanScorecardHeaderShare
} from '../'

import Styles from './PlanScorecardHeader.css'

@CSSModules(Styles, {allowMultiple: true})
export default class PlanScorecardHeader extends Component {
  static propTypes = {
    planId: PropTypes.string.isRequired,
    planData: PropTypes.object.isRequired
  }
  constructor(props){
    super(props)

    const { planId, planData } = props
    const { coreissue } = planData

    let stmt = null
    let bckgrnd = null
    switch (coreissue) {
      case 'deforestation':
        stmt = 'has agribusiness investments that are putting the Amazon rainforest at risk.'
        bckgrnd = 'deforestation'
        break
      case 'prison-industrial-complex':
        stmt = 'is invested in private prison operators and other companies involved in the prison industrial complex.'
        bckgrnd = 'prisons'
        break
      default:
        stmt = 'has coal, oil, and gas investments that are putting the global climate at risk.'
        bckgrnd = 'fossil'
        break
    }

    this.state = {
      planId,
      planData,
      stmt,
      bckgrnd
    }
  }

  render() {
    const { planId, planData, stmt, bckgrnd } = this.state

    // hack for apple video
    if (planData.short_name === 'Apple') {
      return (
        <div styleName={'welcome-banner ' + bckgrnd}>
          <div styleName={'welcome-banner-gray gray-' + bckgrnd}>
            <ContainerDivs>
              <div styleName='welcome-banner-wrap'>
                <h1 styleName='welcome-banner-headline-h1-2'>
                  <div styleName='welcome-banner-headline-2'>
                    {planData.plan_short_name}
                  </div>
                  <div styleName='welcome-banner-headline-stmt-2'>
                    {stmt}
                  </div>
                </h1>
                <PlanScorecardCompanyVideo
                  shortName={planData.short_name}
                />
                <PlanScorecardHeaderShare
                  planId={planId}
                  planName={planData.plan_short_name}
                  companyTwitterHandle={'apple'}
                  companyTicker={'AAPL'}
                />
              </div>
            </ContainerDivs>
          </div>
        </div>
      )
    }

    return (
      <div styleName={'welcome-banner ' + bckgrnd}>
        <div styleName={'welcome-banner-gray gray-' + bckgrnd}>
          <ContainerDivs>
            <div styleName='welcome-banner-wrap'>
              <h1>
                <div styleName='welcome-banner-headline'>
                  {planData.plan_short_name}
                </div>
                <div styleName='welcome-banner-headline-stmt'>
                  {stmt}
                </div>
              </h1>
            </div>
          </ContainerDivs>
        </div>
        <div styleName={'welcome-banner-highlight highlight-' + bckgrnd}>
          <ContainerDivs>
            {
              planData.intro_statement ?
                (
                  <p styleName='welcome-banner-subheading'>
                    {planData.intro_statement}
                  </p>
                ) :
                null
            }
          </ContainerDivs>
        </div>
      </div>
    )
  }
}